export default __webpack_public_path__ + "files/videos/5dc2682629c9c74f278e6d1b508e7fa4.mp4";